import React from 'react';
import {
  Control,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister,
} from 'react-hook-form';
import { SelectOption } from '../../../../../../../../components/Select';
import { LocationValue } from '..';
import { ButtonsRow } from './ButtonsRow';
import { LocationNameInputRow } from './LocationNameInputRow';
import { LocationFieldsInputRow } from './LocationFieldsInputRow';
import { AlertType } from '../../../../../../../../components/Alert';

interface PropTypes {
  handleSubmit: UseFormHandleSubmit<LocationValue>;
  register: UseFormRegister<LocationValue>;
  handleClose: () => void;
  isValid: boolean;
  setSelectedLocation: (selectedOption: SelectOption) => void;
  getValues: UseFormGetValues<LocationValue>;
  control: Control<LocationValue>;
  setAlertType: (alertType: AlertType) => void;
  setAlertMessage: (message: JSX.Element) => void;
}

export function ModalBody(props: PropTypes) {
  return (
    <div className='app-card-body px-3 w-100'>
      <LocationNameInputRow register={props.register} />
      <LocationFieldsInputRow control={props.control} />
      <ButtonsRow
        handleClose={props.handleClose}
        getValues={props.getValues}
        setSelectedLocation={props.setSelectedLocation}
        isValid={props.isValid}
        setAlertType={props.setAlertType}
        setAlertMessage={props.setAlertMessage}
      />
    </div>
  );
}
